// @flow

const policies = {
  type: 'policies',
  selecting: true,
  selectAll: true,
  orderBy: 'policy_id',
  order: 'asc',
  row: {
    click: true,
    action: 'modal',
    modal: {
      app: 'clients',
      tab: 'policyInfo'
    }
  },
  actions: [
    {
      icon: 'Delete',
      title: 'Delete',
      method: 'delete'
    }
  ],
  cells: [
    { id: 'policy_id', label: 'Policy', align: 'left' },
    { id: 'name', label: 'Name', align: 'left' },
    {
      id: 'description',
      label: 'Description',
      align: 'left',
      removeHtml: true,
      hideOrderBy: true
    },
    { id: 'created_date', label: 'Created Date', align: 'left' },
    { id: 'modified_date', label: 'Modified Date', align: 'left' },
    {
      id: 'attachment_link',
      label: 'Download',
      labelAlign: 'center',
      align: 'center',
      button: true,
      val: 'attachment_link',
      renderDowloadIcon: true,
      hideOrderBy: true,
      GAbutton: 'Download Policy'
    }
  ]
};

export default policies;
